module.exports = "Upload Vehicle Deployment Sheet Here\r\n<div style=\"border: 1px solid #ccc; display: flex;border-radius: 5px;padding: 4px;\">\r\n    <input type=\"file\" (change)=\"detectFiles($event)\" [(ngModel)]=\"empUploadImgModel\"\r\n       [ngModelOptions]=\"{standalone: true}\" id=\"doc\" accept=\".xlsx\">\r\n </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/vehicles/deploymentUploader/veh-deployment.component.html
// module id = ./src/app/admin/vehicles/deploymentUploader/veh-deployment.component.html
// module chunks = main